import * as yup from "yup";

export const loaderInfoFormikValidator = yup.object().shape({
  smartCard: yup.string().required("این فیلد الزامی است!"),
});

export const ArmadaInfoFormikValidator = yup.object().shape({
  smartCard: yup.string().required("این فیلد الزامی است!"),
  loaderType: yup.object().required("این فیلد الزامی است!"),
});
